import React, { Component } from 'react';
export function WhatYouGet() {
  const tableData = [{
    item: '📘 VOLUME 1: Little Explorers — 50 Pages',
    value: '$15'
  }, {
    item: '📗 VOLUME 2: Brain Builders — 50 Pages',
    value: '$15'
  }, {
    item: '📙 VOLUME 3: Focus Warriors — 50 Pages',
    value: '$15'
  }, {
    item: '📕 VOLUME 4: Logic Masters — 50 Pages',
    value: '$15'
  }, {
    item: '📒 VOLUME 5: Memory Champions — 50 Pages',
    value: '$15'
  }, {
    item: '📓 VOLUME 6: Young Geniuses — 55 Pages',
    value: '$15'
  }, {
    item: '🎁 BONUS 1: 30-Day Focus Planner',
    value: '$17'
  }, {
    item: '🎁 BONUS 2: Emotion Control for Kids',
    value: '$17'
  }, {
    item: '🎁 BONUS 3: Screen-Free Playbook',
    value: '$17'
  }, {
    item: '🎁 BONUS 4: Parent Quick-Start Guide',
    value: '$17'
  }, {
    item: '🎁 BONUS 5: Focus Rewards System',
    value: '$17'
  }];
  return <section className="bg-cream py-16 px-4 border-t border-border" data-id="element-305">
      <div className="max-w-4xl mx-auto" data-id="element-306">
        <div className="text-center mb-10" data-id="element-307">
          <h2 className="text-3xl md:text-4xl font-heading font-black text-white mb-3" data-id="element-308">
            🎁 EVERYTHING YOU GET TODAY
          </h2>
        </div>

        <div className="overflow-x-auto mb-8 rounded-2xl border border-white/10 shadow-lg bg-navy" data-id="element-309">
          <table className="w-full text-left border-collapse" data-id="element-310">
            <thead data-id="element-311">
              <tr className="bg-black/20 border-b border-white/10" data-id="element-312">
                <th className="p-5 text-white font-heading font-bold w-2/3" data-id="element-313">
                  Component
                </th>
                <th className="p-5 font-heading font-bold w-1/3 text-white text-right" data-id="element-314">
                  Value
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/10" data-id="element-315">
              {tableData.map((row, i) => <tr key={i} className="hover:bg-white/5 transition-colors" data-id="element-316">
                  <td className="p-5 text-ink font-medium" data-id="element-317">{row.item}</td>
                  <td className="p-5 text-muted text-right font-medium" data-id="element-318">
                    {row.value}
                  </td>
                </tr>)}
              <tr className="bg-black/20 border-t border-white/10" data-id="element-319">
                <td className="p-5 text-white font-heading font-bold text-lg" data-id="element-320">
                  TOTAL REAL VALUE
                </td>
                <td className="p-5 text-softred font-bold text-lg text-right line-through" data-id="element-321">
                  $175
                </td>
              </tr>
              <tr className="bg-navy" data-id="element-322">
                <td className="p-6 text-gold font-heading font-black text-xl md:text-2xl" data-id="element-323">
                  YOUR PRICE TODAY
                </td>
                <td className="p-6 text-gold font-heading font-black text-2xl md:text-3xl text-right" data-id="element-324">
                  $19 USD
                </td>
              </tr>
              <tr className="bg-orange" data-id="element-325">
                <td className="p-4 text-white font-heading font-bold text-lg text-center" colSpan={2} data-id="element-326">
                  YOU SAVE $156
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}